// import React from 'react';
// import { useParams } from 'react-router-dom';
// import { projectsData } from '../assets/projects-json/projectsData';
// import Slider from 'react-slick';
// import PagesHeading from '../components/PagesHeading';

// const ProjectDetails = () => {
//   const { id } = useParams();
//   const projectId = parseInt(id); // Ensure it's a number (in case of string)

//   // Find the project by id
//   const project = projectsData.find(p => p.id === projectId);

//   // Handle if project not found
//   if (!project) {
//     return (
//       <div className='p-10 text-center text-red-600'>
//         <h1 className='text-2xl font-bold'>Project Not Found</h1>
//         <p>Please check the URL or go back to the Projects page.</p>
//       </div>
//     );
//   }

//   const { title, intro, screens, features } = project;

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     waitForAnimate: false,
//     autoplay: true,
//     autoplaySpeed: 3000
//   };

//   return (
//     <div>
//       <div className='p-5 md:p-8 bg-gray-100'>
//         <PagesHeading heading="Project Details" />
//       </div>

//       <svg
//         id="wave"
//         className={`w-full h-auto`}
//         style={{ transform: "rotate(180deg)", transition: "0.3s" }}
//         viewBox="0 0 4937 100"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         {/* ...svg gradient wave code remains unchanged... */}
//         {/* You can keep it as-is */}
//       </svg>

//       <div className='flex flex-col items-center justify-center p-2 lg:p-10 max-w-7xl mx-auto gap-y-10 text-start mt-5 lg:mt-10'>
//         <div className='w-full'>
//           <h1 className='text-xl text-start font-semibold'>{title}</h1>
//           <p className='my-2 text-lg text-justify'>{intro}</p>
//         </div>

//         <div className='w-full'>
//           <Slider {...settings}>
//             {screens.map((screen, index) => (
//               <div key={index} className='px-2'>
//                 <img className='drop-shadow rounded-2xl' src={screen} alt={`Screen ${index + 1}`} />
//               </div>
//             ))}
//           </Slider>
//         </div>

//         <div className='grid grid-cols-1 gap-1 w-full'>
//           <h1 className='text-lg font-semibold mb-2'>Features</h1>
//           {features.map((feature, index) => (
//             <div key={index} className='border rounded-lg p-3'>
//               <h2 className='text-lg font-semibold mb-1'>{feature.title}</h2>
//               <p className='text-justify'>{feature.description}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProjectDetails;



import React from 'react';
import { useParams } from 'react-router-dom';
import { projectsData } from '../assets/projects-json/projectsData';
import Slider from 'react-slick';
import PagesHeading from '../components/PagesHeading';

const ProjectDetails = () => {

  const { id } = useParams();
  const projectId = parseInt(id);
  const project = projectsData.find(p => p.id === projectId);
  console.log(id)
  if (!project) {
    return (
      <div className='p-10 text-center text-red-600'>
        <h1 className='text-2xl font-bold'>Project Not Found</h1>
        <p>Please check the URL or go back to the Projects page.</p>
      </div>
    );
  }

  const { title, intro, screens, features, type } = project;

  // Determine slider settings based on type
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: type === 'web' ? 2 : 4,
    slidesToScroll: 1,
    waitForAnimate: false,
    autoplay: true,
    autoplaySpeed: 3000
  };

  return (
    <div>
      <div className='p-5 md:p-8 bg-gray-100'>
        <PagesHeading heading="Project Details" />
      </div>

      <svg
        id="wave"
        className={`w-full h-auto`}
        style={{ transform: "rotate(180deg)", transition: "0.3s" }}
        viewBox="0 0 4937 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* SVG remains unchanged */}
      </svg>

      <div className='flex flex-col items-center justify-center p-2 lg:p-10 max-w-7xl mx-auto gap-y-10 text-start mt-5 lg:mt-10'>
        <div className='w-full'>
          <h1 className='text-xl font-semibold'>{title}</h1>
          <p className='my-2 text-lg text-justify'>{intro}</p>
        </div>

        <div className='w-full'>
          <Slider {...sliderSettings}>
            {screens.map((screen, index) => (
              <div key={index} className='px-2'>
                <img
                  className='drop-shadow rounded-2xl w-full h-auto object-contain'
                  src={screen}
                  alt={`Screen ${index + 1}`}
                />
              </div>
            ))}
          </Slider>
        </div>

        <div className='grid grid-cols-1 gap-1 w-full'>
          <h1 className='text-lg font-semibold mb-2'>Features</h1>
          {features.map((feature, index) => (
            <div key={index} className='border rounded-lg p-3'>
              <h2 className='text-lg font-semibold mb-1'>{feature.title}</h2>
              <p className='text-justify'>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
